import { createApi } from '@reduxjs/toolkit/query/react';
import { getBaseQuery } from './getBaseQuery';
import { CreateUnnamedAreaRequest, CreateUnnamedAreaResponse, DeleteAreaRequest, DeleteAreaResponse, DuplicateAreaRequest, DuplicateAreaResponse, GetAreaRequest, GetAreaResponse, GetAreaSelectorRequest, GetAreaSelectorResponse, GetAreaUuidRequest, GetAreaUuidResponse, PatchAreaUuidRequest, PatchAreaUuidResponse, PostAreaResponse } from './types/TAreaServices';

const URL_Prefix = '/area';

export const areaService = createApi({
    reducerPath: 'areaService',
    baseQuery: getBaseQuery,
    tagTypes: ['Area'],
    endpoints: (builder) => ({
        getArea: builder.query<GetAreaResponse, GetAreaRequest>({
            query: (params) => ({
                url: `${URL_Prefix}/`,
                method: 'GET',
                params: params,
            }),
        }),
        postArea: builder.mutation<PostAreaResponse, GetAreaRequest>({
            query: (body) => ({
                url: `${URL_Prefix}/`,
                method: 'POST',
                body: body
            }),
            invalidatesTags: ['Area'],
        }),
        patchArea: builder.mutation<PatchAreaUuidResponse, PatchAreaUuidRequest>({
            query: (body) => ({
                url: `${URL_Prefix}/${body.uuid}/`,
                method: 'PATCH',
                body: body
            }),
            invalidatesTags: ['Area'],
        }),
        getAreaUuid: builder.query<GetAreaUuidResponse, GetAreaUuidRequest>({
            query: (params) => ({
                url: `${URL_Prefix}/${params.uuid}/`,
                method: 'GET',
                params: params,
            }),
        }),
        duplicateArea: builder.mutation<DuplicateAreaResponse, DuplicateAreaRequest>({
            query: (body) => ({
                url: `${URL_Prefix}/${body.uuid}/duplicate/`,
                method: 'POST',
                body: body
            }),
            invalidatesTags: ['Area'],
        }),
        getAreaSelector: builder.query<GetAreaSelectorResponse, GetAreaSelectorRequest>({
            query: (params) => ({
                url: `${URL_Prefix}/selector/`,
                method: 'GET',
                params: params,
            }),
        }),
        deleteArea: builder.mutation<DeleteAreaResponse, DeleteAreaRequest>({
            query: (body) => ({
                url: `${URL_Prefix}/${body.uuid}/cascade/`,
                method: 'DELETE',
            }),
            invalidatesTags: ['Area'],
        }),
        createUnnamed: builder.mutation<CreateUnnamedAreaResponse, CreateUnnamedAreaRequest>({
            query: (body) => ({
                url: `${URL_Prefix}/create_unnamed/`,
                method: 'POST',
                body: body
            }),
            invalidatesTags: ['Area'],
        }),
    }),
});

// Экспортируем все хуки, включая useLazySendCodeQuery
export const {
    useGetAreaQuery,
    useLazyGetAreaQuery,
    usePostAreaMutation,
    useGetAreaUuidQuery,
    useLazyGetAreaUuidQuery,
    usePatchAreaMutation,
    useDuplicateAreaMutation,
    useGetAreaSelectorQuery,
    useLazyGetAreaSelectorQuery,
    useDeleteAreaMutation,
    useCreateUnnamedMutation
} = areaService;